export default __webpack_public_path__ + "static/media/humidity.2aa53b92.png";